import { combineReducers } from "@reduxjs/toolkit";
import store from "./storeSlice";
import auth from "./authSlice";

const miscReducers = combineReducers({
	store,
	auth,
});

export default miscReducers;
